/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { Quotation } from "./Quotation";
import uniqid from "uniqid";

export class Customer {
    id?: string; // Client-side generated uniqid.

    // TODO: @bm - to be set up
    creationDate?: string;

    title?: "mr" | "mrs" | "miss";
    firstname?: string;
    lastname?: string;
    familyStatus?: "single" | "married" | "divorced" | "widower" | "pacs" | "freeUnion";

    birthname?: string;
    birthdate?: string;
    cityOfBirth?: string;
    departmentOfBirth?: string;
    countryOfBirth?: string;

    address?: string;
    zipcode?: string;
    city?: string;

    phone?: string;
    mobile?: string;
    email?: string;

    vocation?: string;

    optin?: boolean;  // TODO @DP why ?

    idDocument?: "passport" | "identityCard" | "residencePermit";
    addressProof?: "electricityBill" | "phoneBill" | "taxNotice" | "other";
    addressProofOther?: string;

    quotations?: { [quotationId: string]: Quotation };

    static createNew(customer: Customer): Customer {
        return {
            ...customer,
            id: uniqid(),
        };
    }
}


// WEBPACK FOOTER //
// ./src/types/Customer.ts